import { render } from "./AlertDetail.vue?vue&type=template&id=4c9d9b3e&ts=true"
import script from "./AlertDetail.vue?vue&type=script&lang=ts"
export * from "./AlertDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__